(function () {
    'use strict';

    angular
        .module('app')
        .directive('genericTranslation', genericTranslationDirective);

    genericTranslationDirective.$inject = ['API', 'debug',];

    function genericTranslationDirective(API, debug) {
        var directive = {
            restrict: 'AE',
            scope: {
                resource: '@',
                model: '=',
            },
            templateUrl: '/templates/directives/generic-translation.directive.html',
            link: function (scope) {
                var isLoaded = false;
                scope.isLoading = false;
                scope.languages = [];
                scope.strings = {};
                scope.activeLanguage = '';

                function activate() {
                    if (isLoaded || scope.isLoading) {
                        return;
                    }

                    scope.isLoading = true;

                    API[scope.resource].getTranslationStructure({})
                        .$promise
                        .then(function (response) {
                            if (response.languages && response.languages.length) {
                                angular.extend(scope.languages, response.languages);
                            }

                            if (scope.languages.length) {
                                scope.activeLanguage = scope.languages[0];
                            }

                            if (response.strings) {
                                angular.extend(scope.strings, response.strings);
                            }

                            extendModelWithStructure();
                        }, function () {
                            debug.log('Error loading translation structure.');
                        })
                        .finally(function () {
                            isLoaded = true;
                            scope.isLoading = false;
                        });
                }

                function extendModelWithStructure() {
                    angular.forEach(scope.languages, function (language) {
                        if (typeof scope.model.translations[language] === 'undefined') {
                            scope.model.translations[language] = {};
                        }

                        angular.forEach(scope.strings, function (settings, key) {
                            if (typeof scope.model.translations[language][key] === 'undefined') {
                                scope.model.translations[language][key] = '';
                            }
                        });
                    });
                }

                scope.$watch('model', function () {
                    extendModelWithStructure();
                });

                scope.changeLanguage = function (language) {
                    scope.activeLanguage = language;
                };

                activate();
            }
        };

        return directive;
    }
})();